import React, { createContext, useContext, useReducer } from "react";
import { modalReducer, ModalState, ModalAction } from "../reducer/ModalReducer";

const ModalContext = createContext<{
  state: ModalState;
  dispatch: React.Dispatch<ModalAction>;
}>({ state: { activeModal: "NONE" }, dispatch: () => null });

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(modalReducer, {
    activeModal: "NONE",
  });

  return (
    <ModalContext.Provider value={{ state, dispatch }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
